import React from 'react';

import { FormErrorMessage as ChakraFormErrorMessage } from '@chakra-ui/react';

import { Icon } from '../icons';

export function FormErrorMessage({ children, ...props }) {
  return (
    <ChakraFormErrorMessage
      fontSize="7"
      lineHeight="7"
      mt="1"
      color="content.feedback.error.secondary"
      {...props}
    >
      <Icon name="alert" width="16px" height="14px" mr="1" mb="2px" />
      {children}
    </ChakraFormErrorMessage>
  );
}
